import React, { useState, useEffect } from 'react';
import './Main.css';

const TRACK_API = '/php/track_links.php';

export default function Main() {
  const [linkClicks, setLinkClicks] = useState({});

  const [formData, setFormData] = useState({ meno: '', priezvisko: '', email: '', telefon: '', sprava: '', website: '' });
  const [formState, setFormState] = useState('idle');
  const [formError, setFormError] = useState('');
  const [loadTime] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    loadGlobalStats();
  }, []);

  const loadGlobalStats = async () => {
    try {
      const response = await fetch(TRACK_API + '?action=stats');
      const data = await response.json();
      if (data.success) {
        setLinkClicks(data.clicks);
      }
    } catch (error) {
      console.error('Chyba pri načítaní štatistík:', error);
    }
  };

  const trackClick = async (url) => {
    try {
      const response = await fetch(TRACK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url })
      });
      const data = await response.json();
      if (data.success) {
        setLinkClicks(prev => ({ ...prev, [url]: data.total }));
      }
    } catch (error) {
      console.error('Chyba pri trackovaní kliknutia:', error);
    }
  };

  const renderLink = (href, children, props = {}) => {
    return (
      <a
        href={href}
        onClick={() => trackClick(href)}
        {...props}
      >
        {children}
      </a>
    );
  };

  return (
    <main className="main-page">

      {/* NAV */}
      <nav className="main-nav">
        <a href="#domov" className="active">domov</a>
        <a href="#sluzby">naše služby</a>
        <a href="#kontakt">kontakt</a>
      </nav>

      {/* HERO */}
      <section className="hero-section" id="domov" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/hero-bg.jpg)` }}>
        <div className="hero-overlay" />
        <div className="hero-inner">
          <h1 className="hero-title">Vedenie účtovníctva a daní</h1>
          <p className="hero-subtitle">Komplexné spracovanie účtovnej agendy a miezd.</p>
          <p className="hero-location">Poprad · Liptovský Mikuláš · Bratislava</p>
        </div>
      </section>

      {/* O NAS */}
      <section className="about-section">
        <div className="about-inner">
          <h2 className="about-heading">O nás</h2>
          <p className="about-subtitle">Účtovníctvo bez zbytočnej administratívy pre vás.</p>
          <p className="about-text">
            Zameriavame sa na komplexné spracovanie účtovníctva a miezd pre živnostníkov
            a obchodné spoločnosti (s.r.o.) po celom Slovensku – od Bratislavy až po Poprad.
            Naším cieľom je, aby ste sa mohli naplno venovať svojmu podnikaniu,
            zatiaľ čo my sa postaráme o vaše čísla.
          </p>
          <p className="about-subheading">Čím sme iní?</p>
          <p className="about-text">
            <strong>Žiadne povinné skenovanie.</strong> Rešpektujeme váš čas. Od klientov
            nevyžadujeme digitalizáciu papierových dokladov. Čo máte v papierovej forme,
            si preberieme osobne. Digitálne spracovávame len tie dokumenty, ktoré vám
            už v elektronickej podobe prirodzene chodia.
          </p>
          <p className="about-text">
            <strong>Odbornosť bez stagnácie.</strong> Hoci nie sme daňoví poradcovia,
            kladieme maximálny dôraz na kontinuálne vzdelávanie. Sledujeme neustále zmeny
            v legislatíve, mzdových predpisoch a daniach, aby sme vám garantovali
            aktuálnosť a správnosť vašich výstupov.
          </p>
          <p className="about-text">
            <strong>Skúsenosti naprieč segmentmi.</strong> Rozumieme špecifikám rôznych
            odvetví. Medzi našich klientov patria firmy z oblastí stavebníctva (zemné
            a cestné práce), gastra, elektroinštalácií, polygrafie, automotive dizajnu,
            ako aj drobnej výroby a služieb.
          </p>
          <p className="about-closing">
            Vaše účtovníctvo vnímame ako partnerstvo postavené na dôvere a odbornosti.
          </p>
        </div>
      </section>

      {/* NASE SLUZBY */}
      <section className="services-section" id="sluzby">
        <h2 className="section-title">Naše služby</h2>
        <div className="services-list">
          <div className="service-item">
            <h3>Vedenie účtovníctva</h3>
            <p>Neriešime len prípravu, ale celý životný cyklus vašich dokladov. Zabezpečíme vedenie podvojného a jednoduchého účtovníctva, spracovanie daňových priznaní (DPPO, DPFO, DPH) a vypracovanie aj podanie účtovnej závierky vrátane všetkých povinných príloh do registra. Vy len podnikáte, my komunikujeme s úradmi.</p>
          </div>
          <div className="service-item">
            <h3>Mzdy a personálna agenda</h3>
            <p>Preberáme kompletnú starostlivosť o vašich zamestnancov. Od prihlasovania do poisťovní, cez mesačné výpočty miezd a zasielanie výkazov, až po ročné zúčtovania. Všetko podávame elektronicky v zákonných termínoch.</p>
          </div>
          <div className="service-item">
            <h3>Administratíva bez skenovania</h3>
            <p>Unikátny systém preberania dokladov. Papierovú agendu si vyzdvihneme osobne, digitálnu spracujeme priamo z vašich e-mailov. Žiadne zbytočné skenovanie ani nahrávanie do externých systémov z vašej strany.</p>
          </div>
        </div>
        <div className="services-wide-card">
          <h3>Zakladanie a zmeny firiem</h3>
          <p>Chystáte sa podnikať alebo potrebujete zmenu? Použite služby online — rýchlo a bez úradov.</p>
          <div className="services-wide-links">
            <div className="services-wide-links-row">
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6", "Založiť živnosť", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-zalozenie-zivnosti") })}
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fpozastavenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6", "Pozastaviť živnosť", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-pozastavenie-zivnosti") })}
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzrusenie-zivnosti%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6", "Zrušiť živnosť", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-zrusenie-zivnosti") })}
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-firmy%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6", "Založiť s.r.o.", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-zalozenie-firmy") })}
            </div>
            <div className="services-wide-links-row services-wide-links-row--center">
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzmeny-vo-firme%3Futm_source%3Daff%26utm_medium%3Ddgt%26a_aid%3D5cad8a017abda%26a_bid%3D719a5aa6%26visitorId%3Dcm0GNbVcC94CgpYVf2CGrlL4hSBTv6d2", "Zmeny v s.r.o.", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-zmeny-vo-firme") })}
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.firmaren.sk%2Fzalozenie-obcianskeho-zdruzenia%3Futm_source%3Daff", "Občianske združenie", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("firmaren-obcianske-zdruzenie") })}
              {renderLink("https://go.dognet.com/?chid=GOXLaXhD&url=https%3A%2F%2Fwww.netfinancie.sk%2F", "Poistenie online", { target: "_blank", rel: "noopener noreferrer", className: "service-wide-btn", onClick: () => trackClick("netfinancie") })}
            </div>
          </div>
        </div>
      </section>

      {/* UZITOCNE ODKAZY */}
      <section className="links-section">
        <h2 className="section-title">Užitočné odkazy</h2>
        <div className="links-grid">

          <div className="links-group">
            <h4>Finančná správa &amp; registre</h4>
            {renderLink("https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/overenie-prideleneho-oud", "Overenie OUD", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.pokladnica.sk/_img/Documents/sluzby/IBAN/IBAN_generator_validator.html", "IBAN validátor", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/vytvorenie-platobnych-instrukc/vytvorenie-platobnych-instrukc", "Generovanie QR kódu a plat. inštrukcií", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://zber.statistics.sk/register-organizacii?_sk_susr_isis_pub_organisations_register_portlet_OrganisationsRegisterPortlet_INSTANCE_puzm_navigationType=SEARCH_VIEW", "SK.NACE / register organizácií", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.financnasprava.sk/_img/pfsedit/Dokumenty_PFS/Zverejnovanie_dok/Aktualne/DPH/2022/2022.06.23_CPA_klasif.pdf", "CPA klasifikácia (PDF)", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/detail/_101c6128-e1f6-4a48-81ed-ad3c01220e03", "Overenie IČ DPH SR", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/detail/_0c383ed5-f19a-4464-a60f-ad5000af6c51", "Overenie DIČ SR", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.registeruz.sk/cruz-public/domain/accountingentity/simplesearch", "Register účtovných závierok", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.slov-lex.sk/ezbierky/pravne-predpisy/SK/ZZ/2003/595/20250401#poznamky", "Zákon o dani z príjmov (odpisy)", { target: "_blank", rel: "noopener noreferrer" })}
          </div>

          <div className="links-group">
            <h4>Portály &amp; poisťovne</h4>
            {renderLink("https://pfs.iam.financnasprava.sk/PREZ/idp/authn?authnGuid=c46eaf8d-766d-4603-b10b-fee5da60ccb8", "Finančná správa — login", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.slovensko.sk/sk/titulna-stranka", "Slovensko.sk", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.zakonypreludi.sk", "Zákony pre ľudí", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.socpoist.sk/", "Sociálna poisťovňa", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.udzs-sk.sk/dohlad-nad-zdravotnym-poistenim/informacie-o-zdravotnom-poisteni/zdravotne-poistovne-kody-od-01-01-2010/", "Kódy zdravotných poisťovní", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.portaludzs.sk/web/eportal/", "Overenie poistného vzťahu zamestnanca", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://www.epobocka.com/ipep-web-ng/", "VŠZP — login", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://ep.dovera.sk/Login.aspx?ReturnUrl=%2f", "Dôvera — login", { target: "_blank", rel: "noopener noreferrer" })}
            {renderLink("https://portal.unionzp.sk/onlinepobocka/welcome", "Union — login", { target: "_blank", rel: "noopener noreferrer" })}
          </div>

          <div className="links-group">
            <h4>Interné</h4>
            <ul>
              <li>{renderLink("https://docs.google.com/forms/u/0/d/e/1FAIpQLScTnqsL6lfWVQ-lJirDh_jZFwuUEGzSMRz7ez5D9ScorSgt2w/formResponse", "Dotazník zamestnanca", { target: "_blank", rel: "noopener noreferrer", title: "employee" })}</li>
              <li>{renderLink("/povinnosti", "Povinnosti", { target: "_blank", title: "povinnosti" })}</li>
              <li>{renderLink("/personalistika", "Personalistika", { target: "_blank", title: "personalistika" })}</li>
              <li>{renderLink("/kalkulacka", "Kalkulačka", { target: "_blank", title: "kalkulacka" })}</li>
              <li>{renderLink("/dovolenka", "Dovolenkový lístok", { target: "_blank", title: "dovolenka" })}</li>
            </ul>
          </div>

        </div>
      </section>

      {/* KONTAKT */}
      <section className="contact-section" id="kontakt">
        <h2 className="section-title">Kontakt</h2>
        <div className="contact-grid">
          <div className="contact-info-box">
            <h3 className="contact-box-title">Kontakt</h3>
            <p className="contact-box-text">Email:<br /><a href="mailto:info@uctovnictvo-poprad.sk">info@uctovnictvo-poprad.sk</a></p>
            <p className="contact-box-text">mobil: <a href="tel:+421950490810">+421 950 490 810</a></p>
          </div>
          <div className="contact-info-box">
            <h3 className="contact-box-title">Pracujeme v:</h3>
            <p className="contact-box-text">Po – Pia: 8:30 – 14:00</p>
            <p className="contact-box-text">Víkendy:<br />v prípade potreby 14:00 – 16:00</p>
          </div>
        </div>
        <div className="contact-form-wrap">
          <h3 className="contact-form-title">Kontaktujte nás</h3>
          {formState === 'sent' ? (
            <p className="contact-form-thanks">Ďakujeme! Správa bola odoslaná, ozveme sa vám čoskoro.</p>
          ) : (
            <form className="contact-form" onSubmit={async e => {
              e.preventDefault();
              setFormState('sending');
              setFormError('');
              try {
                const res = await fetch('/php/contact.php', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ ...formData, load_time: loadTime })
                });
                const data = await res.json();
                if (data.ok) {
                  setFormState('sent');
                } else {
                  setFormError(data.error || 'Nepodarilo sa odoslať správu.');
                  setFormState('error');
                }
              } catch {
                setFormError('Chyba siete. Skúste nás kontaktovať priamo.');
                setFormState('error');
              }
            }}>
              <input type="text" name="website" value={formData.website} onChange={e => setFormData(p => ({ ...p, website: e.target.value }))} style={{ display: 'none' }} tabIndex={-1} autoComplete="off" />
              <div className="contact-form-row">
                <input className="contact-form-input" type="text" placeholder="Meno" required value={formData.meno} onChange={e => setFormData(p => ({ ...p, meno: e.target.value }))} />
                <input className="contact-form-input" type="text" placeholder="Priezvisko" required value={formData.priezvisko} onChange={e => setFormData(p => ({ ...p, priezvisko: e.target.value }))} />
              </div>
              <div className="contact-form-row">
                <input className="contact-form-input" type="email" placeholder="Email" required value={formData.email} onChange={e => setFormData(p => ({ ...p, email: e.target.value }))} />
                <input className="contact-form-input" type="tel" placeholder="Telefón" value={formData.telefon} onChange={e => setFormData(p => ({ ...p, telefon: e.target.value }))} />
              </div>
              <textarea className="contact-form-textarea" placeholder="Sem napíšte svoju správu alebo žiadosť o cenovú ponuku..." rows={5} required value={formData.sprava} onChange={e => setFormData(p => ({ ...p, sprava: e.target.value }))} />
              {formState === 'error' && <p className="contact-form-error">{formError}</p>}
              <div className="contact-form-footer">
                <button className="contact-form-submit" type="submit" disabled={formState === 'sending'}>
                  {formState === 'sending' ? 'Odosielam...' : 'Odoslať správu'}
                </button>
              </div>
            </form>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer className="main-footer">
        <div className="main-footer-inner">
          <p className="main-footer-company">účtovníctvo-poprad.sk s. r. o.</p>
          <p className="main-footer-address">Karpatské námestie 7770/10A, Bratislava – mestská časť Rača 831 06</p>
          <p className="main-footer-ico">IČO: 57 422 745</p>
          <p className="main-footer-copy">© {new Date().getFullYear()} účtovníctvo-poprad.sk s. r. o. Všetky práva vyhradené.</p>
        </div>
      </footer>

    </main>
  );
}
